import React, { useState } from "react";
import { createUseStyles } from "react-jss";
import Loader from "../../../../components/Loader";
import _ from "lodash";
import {
  genericIndexesStyles,
  btnStyles,
  tableStyles,
  variables,
} from "../../../../variables";
import Navbar from "./Navbar";
import ControlStrip from "../../../../components/ControlStrip";
import { handleApplyFilters, medWeekdayDatetimer } from "../../../../helpers";
import ReservationStats from "../../CommonCRSModals/ReservationStats/ReservationStats";
import { commonTableHeaders } from "../../helpers";
import { useQueries } from "@tanstack/react-query";
import {
  fetchFerryApiReservations,
  getFerryApiReservationStats,
} from "../../../../api/CRS/FerriesApi";
import DetailApiFerriesModal from "../ApiFerriesModals/DetailsFerriesApiModal";
import HamburgerMenu from "../../../../components/HamburgerMenu";
import { genericRequestErrorHandler } from "../../../../api";
import { useListPageSidebar } from "../../../../hooks";
import * as yup from "yup";
import { DateTime } from "luxon";
import { CustomButton } from "../../../../components/CustomButton";

const initialFilters = {
  limit: 20,
  page: 1,
  ordering: "",
  discending: "",
  inbound_company__icontains: "",
  outbound_company__icontains: "",
  inbound_destination__icontains: "",
  outbound_destination__icontains: "",
  inbound_arrival__gte: "",
  inbound_departure__lte: "",
  outbound_arrival__gte: "",
  outbound_departure__lte: "",
  created__gte: "",
  created__lte: "",
  external_reference__icontains: "",
  source_entity: "",
  network_search: "",
  supplier_reference: "",
  reference: "",
  market_type: "",
  status: "",
};
const navbarSchema = yup.object().shape({
  outbound_company__icontains: yup
    .string()
    .min(1, "Outbound Company Name must be more than 1 characters")
    .max(100, "Outbound Company Name must be less than 100 characters"),
  created__gte: yup.date(),
  created__lte: yup.date().max(new Date(), "Date cannot be in the future"),
});

const apiFerriesStyles = createUseStyles({
  ApiFerries: {
    ...genericIndexesStyles.indexes.mobile(),
    gridTemplateRows: "auto auto auto  1fr",
  },
  tableContainer: genericIndexesStyles.tableContainer.mobile(),
  table: tableStyles.table,
  headRow: tableStyles.head.row,
  headCell: tableStyles.head.cell,
  bodyRow: tableStyles.body.row,
  tablecell: tableStyles.body.cell,
  actionCell: {
    ...tableStyles.body.cell,
    gap: variables.half_gap,
  },
  dateCell: { ...tableStyles.body.cell, minWidth: "9rem" },
  checkBox: {
    width: `calc${variables.normal_gap} * 1.5`,
    height: `calc${variables.normal_gap} *1.5`,
  },
  btn: btnStyles.btn,
  [`@media ${variables.media.smallscreen}`]: {
    tableCell: {
      padding: `calc(${variables.normal_gap} * 2.5) 0`,
    },
  },
});

const ApiFerries = () => {
  const classes = apiFerriesStyles();

  useListPageSidebar();

  const [filters, setFilters] = useState(initialFilters);
  const [reference, setReference] = useState(null);
  const [showDetailModal, setShowDetailModal] = useState(false);

  const tableHeaders = commonTableHeaders({
    "Supplier Reference": (val) => val.supplier_reference,
    "Outbound Company": (val) => val.outbound_company,
    "Outbound Departure": (val) => val.outbound_departure,
    "Outbound Arrival": (val) => val.outbound_arrival,
    "Outbound Destination Port": (val) => val.outbound_destination_port,
    "Outbound Destination": (val) => val.outbound_destination,
    "Inbound Company": (val) => val.inpound_company,
    "Inbound Departure": (val) => val.inbound_departure,
    "Inbound Arrival": (val) => val.inbound_arrival,
    "Inbound Destination Port": (val) => val.inbound_destination_port,
    "Inbound Destination": (val) => val.inbound_destination,
    "Payment Mode": (val) => val.payment_mode_display,
    Tags: (val) => _.get(val, "tags", []).join(","),
    Adults: (val) => val.adults,
    Children: (val) => val.children || "0",
    "Tickets Classes": (val) =>
      _.get(val, "ticket_classes", [])
        .map((tc) => _.startCase(tc))
        .join(","),
    "Market Type": (val) => val.market_type,
  });

  const handleApplyLocalFilters = (filters) => {
    handleApplyFilters(filters, setFilters, navbarSchema);
  };

  const results = useQueries({
    queries: [
      {
        queryKey: ["ferriesApi", filters],
        queryFn: async () => {
          let correctPayload = { ...filters };
          if (filters.created__lte) {
            correctPayload["created__lte"] = DateTime.fromISO(
              filters.created__lte
            ).toISO();
          }
          if (filters.created__gte) {
            correctPayload["created__gte"] = DateTime.fromISO(
              filters.created__gte
            ).toISO();
          }
          if (filters.outbound_arrival__gte) {
            correctPayload["outbound_arrival__gte"] = DateTime.fromISO(
              filters.outbound_arrival__gte
            ).toISO();
          }
          if (filters.outbound_departure__lte) {
            correctPayload["outbound_departure__lte"] = DateTime.fromISO(
              filters.outbound_departure__lte
            ).toISO();
          }
          if (filters.inbound_arrival__gte) {
            correctPayload["inbound_arrival__gte"] = DateTime.fromISO(
              filters.inbound_arrival__gte
            ).toISO();
          }
          if (filters.inbound_departure__lte) {
            correctPayload["inbound_departure__lte"] = DateTime.fromISO(
              filters.inbound_departure__lte
            ).toISO();
          }
          return fetchFerryApiReservations({
            params: correctPayload,
          });
        },
        enabled: !showDetailModal,
        onError: (error) => genericRequestErrorHandler(error),
      },
      {
        queryKey: ["ferriesApiStats", filters],
        queryFn: async () => {
          let correctPayload = { ...filters };
          if (filters.created__lte) {
            correctPayload["created__lte"] = DateTime.fromISO(
              filters.created__lte
            ).toISO();
          }
          if (filters.created__gte) {
            correctPayload["created__gte"] = DateTime.fromISO(
              filters.created__gte
            ).toISO();
          }
          if (filters.inbound_arrival__gte) {
            correctPayload["inbound_arrival__gte"] = DateTime.fromISO(
              filters.created__lte
            ).toISO();
          }
          if (filters.inbound_departure__lte) {
            correctPayload["inbound_departure__lte"] = DateTime.fromISO(
              filters.created__gte
            ).toISO();
          }
          if (filters.outbound_arrival__gte) {
            correctPayload["outbound_arrival__gte"] = DateTime.fromISO(
              filters.created__lte
            ).toISO();
          }
          if (filters.outbound_arrival__gte) {
            correctPayload["created__gte"] = DateTime.fromISO(
              filters.created__gte
            ).toISO();
          }
          if (filters.outbound_departure__lte) {
            correctPayload["outbound_departure__lte"] = DateTime.fromISO(
              filters.created__lte
            ).toISO();
          }
          if (filters.created__gte) {
            correctPayload["created__gte"] = DateTime.fromISO(
              filters.created__gte
            ).toISO();
          }
          return getFerryApiReservationStats({
            params: correctPayload,
          });
        },
        enabled: !showDetailModal,
      },
    ],
  });

  return (
    <div id="APIFERListPage" className={classes.ApiFerries}>
      <Navbar
        filters={filters}
        initialFilters={initialFilters}
        onApplyFilters={handleApplyLocalFilters}
      />
      <HamburgerMenu />
      {!_.get(results, "1.isLoading", true) &&
        _.get(results, "1.data", null) && (
          <ReservationStats
            title="Reservation Stats"
            stats={_.get(results, "1.data.data.stats_per_currency")}
          />
        )}
      <ControlStrip
        limit={_.get(filters, "limit")}
        page={filters.page}
        count={_.get(results, "0.data.data.count")}
        onChangeLimit={(limit) => setFilters({ ...filters, limit, page: 1 })}
        onChangePage={(page) => setFilters({ ...filters, page })}
        orderOptions={[["created", "Created"]]}
        onChangeOrderOptions={(ordering) =>
          setFilters({ ...filters, ordering })
        }
      />
      {_.get(results, "0.isLoading", false) ? (
        <Loader />
      ) : (
        <div className={classes.tableContainer}>
          <table className={classes.table}>
            <thead className={classes.thead}>
              <tr className={classes.headRow}>
                <th className={classes.headCell}>#</th>
                {Object.keys(tableHeaders).map((value, idx) => (
                  <th className={classes.headCell} key={idx}>
                    {value}
                  </th>
                ))}
                <th className={classes.headCell}>Actions</th>
              </tr>
            </thead>
            <tbody>
              {_.get(results, "0.data.data.results", []).map((val, idx) => (
                <tr className={classes.bodyRow} key={idx}>
                  <td className={classes.tablecell}>{idx + 1}</td>
                  {Object.entries(tableHeaders).map((entry, ridx) => {
                    var cell = null;
                    const fn = entry[1];
                    switch (entry[0].toLowerCase()) {
                      case "inbound arrival":
                        cell = fn(val) ? medWeekdayDatetimer(fn(val)) : "N/A";
                        return (
                          <td className={classes.dateCell} key={ridx}>
                            {cell}
                          </td>
                        );
                      case "outbound arrival":
                        cell = fn(val) ? medWeekdayDatetimer(fn(val)) : "N/A";
                        return (
                          <td className={classes.dateCell} key={ridx}>
                            {cell}
                          </td>
                        );
                      case "inbound departure":
                        cell = fn(val) ? medWeekdayDatetimer(fn(val)) : "N/A";
                        return (
                          <td className={classes.dateCell} key={ridx}>
                            {cell}
                          </td>
                        );
                      case "outbound departure":
                        cell = fn(val) ? medWeekdayDatetimer(fn(val)) : "N/A";
                        return (
                          <td className={classes.dateCell} key={ridx}>
                            {cell}
                          </td>
                        );
                      case "created":
                        cell = fn(val) ? medWeekdayDatetimer(fn(val)) : "N/A";
                        return (
                          <td className={classes.dateCell} key={ridx}>
                            {cell}
                          </td>
                        );
                      default:
                        cell = fn(val) || "N/A";
                        break;
                    }
                    return (
                      <td className={classes.tablecell} key={ridx}>
                        {cell}
                      </td>
                    );
                  })}
                  <td className={classes.actionCell}>
                    <CustomButton
                      id={`detailAPIFERButton_${idx}`}
                      appearance="ghost"
                      onClick={() => {
                        setReference(val.reference);
                        setShowDetailModal(true);
                      }}>
                      <strong>Details</strong>
                    </CustomButton>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
      {showDetailModal && (
        <DetailApiFerriesModal
          onClose={() => setShowDetailModal(false)}
          reference={reference}
        />
      )}
    </div>
  );
};

export default ApiFerries;
